import { INewbuildingContactsState } from '../../types/phone/phone';
import { IApplicationState } from '../../types/redux';

export const selectCallPopup = (state: IApplicationState): INewbuildingContactsState | null => {
  return state.callPopup;
};
